import axios from 'axios'
import QS from 'qs';
import baseUrl from "./baseUrl";
import * as qiniu from 'qiniu-js';
import Cookies from 'js-cookie';

//请求超时时间。例如超过了10s，就会告知用户当前请求超时
axios.defaults.timeout = 10000

//axios默认请求头发起post的请求会发两遍，修改请求头后通过qs模块将数据处理后发送服务端
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.headers.common["agent-token"] = localStorage.getItem("agent-token");
if(Cookies.get('agent-token')){
    axios.defaults.headers.common["agent-token"] = Cookies.get('agent-token');
}
axios.defaults.headers.common["user-ip"] = returnCitySN.cip;
 /**
   * get方法，对应get请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求时携带的参数]
   */
export function getData(url, params){
    axios.defaults.headers.common["agent-token"] = localStorage.getItem("agent-token");
    axios.defaults.headers.common["user-ip"] = returnCitySN.cip;
    if(Cookies.get('agent-token')){
        axios.defaults.headers.common["agent-token"] = Cookies.get('agent-token');
    }
    return new Promise((resolve, reject) =>{
        axios.get(url, {
            params: params
        })
        .then(res => {
            resolve(res);
        })
        .catch(err => {
            reject(err)
        })
    });
}
/**
  * post方法，对应post请求
  * @param {String} url [请求的url地址]
  * @param {Object} params [请求时携带的参数]
  */
export function postData(url, params) {
  axios.defaults.headers.common["agent-token"] = localStorage.getItem("agent-token");
    if(Cookies.get('agent-token')){
        axios.defaults.headers.common["agent-token"] = Cookies.get('agent-token');
    }
  axios.defaults.headers.common["user-ip"] = returnCitySN.cip;
  return new Promise((resolve, reject) => {
      axios.post(url, QS.stringify(params))
      .then(res => {
          resolve(res);
      })
      .catch(err => {
          reject(err)
      })
  });
}

export function warrantPostData(url, params, key, token) {
    axios.defaults.headers.common["admin-token"] = localStorage.getItem("admin-token");
    if(Cookies.get('agent-token')){
        axios.defaults.headers.common["agent-token"] = Cookies.get('agent-token');
    }
    axios.defaults.headers.common["user-ip"] = returnCitySN.cip;
    axios.defaults.headers.common[key] = token;
    return new Promise((resolve, reject) => {
        axios.post(url, QS.stringify(params))
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err)
            })
    });
}
// 阿里云上传
export async function OSSuploadPost({res,callback,progress,type = 'image'} = option){
  console.log('upload------------>')
  let obj1 = await get_signature(res.file.name,type)
  let obj = JSON.parse(obj1)
  var formData = new FormData();
  formData.append('key', obj.data.key);
  formData.append('OSSAccessKeyId', obj.data.uptoken.accessid);
  formData.append('policy', obj.data.uptoken.policy);
  formData.append('Signature', obj.data.uptoken.signature);
  formData.append('success_action_status', 200); //成功后返回的操作码
  formData.append("file", res.file);
  var url = obj.data.uptoken.host;
  $.ajax({
    url: url,
    type: 'POST',
    data: formData,
    cache: false,
    contentType: false,
    processData: false,
    xhr: function() {
    var xhr = null;
        if (window.XMLHttpRequest){
        xhr=new XMLHttpRequest();
        }else if (window.ActiveXObject){
        xhr=new ActiveXObject("Microsoft.XMLHTTP");
        }
        xhr.upload.addEventListener('progress', function (progressEvent) {
            progress && progress(progressEvent, res)
        })
        return xhr;
    },
    success: function (data) {
        let url = type == 'video'||type == 'videosource'?obj.data.key:`${obj.data.domain}/${obj.data.key}`
        res.onSuccess&&res.onSuccess({
          file_url: url
        })
        callback && callback(url, res)
    },
    error: function (err) {
        console.log('err',err);
        res.onSuccess&&res.onSuccess()
    }
  });
}
// 阿里云上传 获取签名  
function get_signature(filename,type = 'image') {
return new Promise(res =>{
    var param = {
        // type: type,
        file_name: filename,
    };
    postData('/agent/upload/getToken', param).then(res1 => {
        res(res1.data)
    })
})
}
//七牛云 上传凭证接口
export function qiniuPost(data,that,item,callback) {
  console.log("111111111111",data);
  var _this = this;
  var param = {
    file_name:data.file.name,
  };
  var file_size = 0;
  var config = {
    useCdnDomain: true,
    region: qiniu.region.z2
  };
  postData('/agent/upload/getToken',param).then(res=>{
    var observable = qiniu.upload(
        data.file,
        res.data.data.key,
        res.data.data.uptoken,
        {
          fname: data.file.name,
          params: {},
          mimeType: [],
        },
        {
          useCdnDomain: true,
        },
     );
    observable.subscribe({
      next(res){
        file_size = res.total.size;
      },
      error(err){
        data.onSuccess();
      },
      complete(sub_res){
        //根据上传成功信息返回图片
        var file_url = res.data.data.domain+res.data.data.key;
        data.onSuccess({"type":item, "file_url":file_url});
        that[item] = file_url;
        if(typeof that.ruleForm != 'undefined'){
          that.ruleForm[item] = file_url;
        }
        if(callback){
          callback&&callback(file_url,that);
        }else{
          that.$loading().close();
        }
      }
    })
  });
}

//七牛云 上传凭证接口
export function qiniuPostNew(data,callback) {
  var _this = this;
  var param = {
    file_name:data.file.name,
  };
  var file_size = 0;
  var config = {
    useCdnDomain: true,
    region: qiniu.region.z2
  };
  postData('/agent/upload/getToken',param).then(res=>{
    var observable = qiniu.upload(
        data.file,
        res.data.data.key,
        res.data.data.uptoken,
        {
          fname: data.file.name,
          params: {},
          mimeType: [],
        },
        {
          useCdnDomain: true,
        },
     );
    observable.subscribe({
      next(res){
        file_size = res.total.size;
      },
      error(err){
        data.onSuccess();
      },
      complete(sub_res){
        //根据上传成功信息返回图片
        var file_url = res.data.data.domain+res.data.data.key;
        data.onSuccess({"file_url":file_url});
        callback(file_url);
        // that.$loading().close();
      }
    })
  });
}



// WEBPACK FOOTER //
// ./src/agent/assets/js/httpRequest.js